// extracted by mini-css-extract-plugin
export default {"circularWrapper":"CallProgress_circularWrapper__RirWa","circular":"CallProgress_circular__FwDeK"};